import ComingSoon from "../components/comingSoon";
import { GrBusinessService } from "react-icons/gr";
import { FaRegCircle } from "react-icons/fa";
import StoreList from '../views/Store/List';
import AddStore from '../views/Store/Add';

const StoreManagementRoutes = [
  {
    path: "/store-management",
    name: "Stores Management",
    icon: <GrBusinessService />,
    component: "",
    layout: "/admin",
    showInSidebar: true,
    subNav: [
      {
        path: "/store/list",
        title: "Store List",
        icon: <FaRegCircle />,
        component: <StoreList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      },
      {
        path: "/store/add",
        title: "Add Store",
        icon: <FaRegCircle />,
        component: <AddStore />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true
      },
    ],
  }
];

export default StoreManagementRoutes;
